import React from 'react'
import "./modal.scss"
import { useNavigate } from 'react-router-dom'


function ModalContainer({title,navigation, children, style }) {
    let navigate = useNavigate()
    return (
        <div className="modal fade show bg-black bg-opacity-70" style={{...style}}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    {/* header */}
                    <div className="modal-header">
                        <div className="myacc_tab_sec">
                            <button type="button" data-toggle="tooltip" data-html="true"
                                title="Press Space button to close the popup window" className="btn-close popup-close"
                                data-bs-dismiss="modal"
                                onClick={()=>navigate(navigation)}
                                ><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"></path> </g></svg></button>
                            <ul className="myacc_tab_nav nav" role="tablist">
                                <li className="nav-item">
                                    <p className="nav-link">
                                        {title}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* body */}
                    <div className="modal-body">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalContainer